import { useTranslation } from 'react-i18next';
import { faClose } from '@seeqdev/icons/fa-sharp-regular-svg-icons';
import { Icon } from '@seeqdev/qomponents';

interface SearchResultRemovableProps {
  itemId: string;
  itemIcon: React.ReactNode;
  itemName: string;
  itemAncestors?: string;
  onRemove: (itemId: string) => void;
}

export const SearchResultRemovable = ({
  itemId,
  itemIcon,
  itemName,
  itemAncestors,
  onRemove,
}: SearchResultRemovableProps) => {
  const { t } = useTranslation();

  return (
    <div key={`key_${itemId}`} className="flexRowContainer flexFill removableSearchResult">
      <div className="flexColumnContainer flexFill tw:items-center tw:justify-center">
        {itemIcon}
        <div className="searchResultName flexFill">
          <span className="simple-word-break">{itemName}</span>
          {itemAncestors && (
            <span className="xsmall sq-fairly-dark-gray simple-word-break tw:ml-sq-5 tw:pb-0.5 tw:italic">
              {itemAncestors}
            </span>
          )}
        </div>
        <Icon
          icon={faClose}
          type="text"
          onClick={() => onRemove(itemId)}
          testId="removeSearchResult"
          tooltip={t('SEARCH_DATA.REMOVABLE_RESULT_TOOLTIP')}
          extraClassNames="mr10 cursorPointer"
        />
      </div>
    </div>
  );
};
